export default __webpack_public_path__ + "static/media/Linkedin-icon.dc80b321.svg";